import styled from "styled-components";

import { StyledStatus } from "@/components/atoms/Status/styled";
import { breakpoints } from "@/styles/breakpoints";

export const StyledDetailPanel = styled.div<{
    $clickable: boolean;
    $detailPanelInfoGroup: boolean;
    $lastDetailPanelInGroup: boolean;
}>`
    width: calc(50% - 10px);
    padding: 0 5px 5px;
    font-size: var(--size-16);
    font-weight: 400;
    line-height: 24px;

    .hidden {
        display: none !important;
    }

    .accordion-root {
        background: transparent;
        box-shadow: none;

        .accordion-summary-root {
            min-height: 40px;
            padding: 0 4px 0 0 !important;
            box-shadow: none;

            .MuiIconButton-root {
                svg {
                    path {
                        fill: var(--color-secondary);
                    }
                }
            }

            .accordion-summary-expandIcon {
                margin-right: 0;
            }

            .accordion-summary-content {
                margin: 8px 0;
                font-size: var(--size-14);
                line-height: 21px;
                color: var(--color-secondary);
                text-transform: uppercase;
            }
        }

        .MuiCollapse-root {
            margin-top: 10px;
            background: var(--color-secondary-light);

            @media ${breakpoints.xs} {
                background: var(--color-white);
            }

            border-radius: var(--radius-10);

            .accordion-details-root {
                display: block;
                padding: 8px 8px 16px;

                .contentPanel {
                    @media ${breakpoints.xs} {
                        width: auto;
                        padding: 8px;
                    }
                }
            }
        }
    }

    ${(props) =>
        props.$detailPanelInfoGroup &&
        `
            &:nth-child(2) {
                margin-top: 27px;
                @media ${breakpoints.xs} {
                    margin-top: 10px;
                }
            }
        `}
    ${(props) =>
        props.$lastDetailPanelInGroup &&
        `
            &:nth-child(odd) {
                margin-right: 10px;
                @media ${breakpoints.xs} {
                    margin-right: 0;
                }
            }
        `}
    .accordion-summary-expandIcon {
        svg {
            width: 16px;
            height: 18px;

            path {
                fill: var(--color-secondary);
            }
        }
    }

    @media ${breakpoints.xs} {
        width: 100%;
        padding: 0;
    }

    .titlePanel {
        margin: 10px 0;
        color: var(--color-primary);
        text-align: left;
    }

    .contentPanel {
        padding: 15px 20px;
        background-color: var(--color-white);
        border-radius: var(--radius-10);
        @media ${breakpoints.xs} {
            width: auto;
        }

        ${StyledStatus} {
            text-align: right;
            display: block;
            margin-bottom: 5px;
        }

        ${(props) =>
            props.$clickable &&
            `
            cursor: pointer;
            filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.15));
        `}
        .infoContainer {
            display: flex;
            margin-bottom: 5px;
            overflow: hidden;
            gap: 10px;

            &:last-child {
                margin-bottom: 0;
            }

            .labelPanelSection {
                position: relative;
                flex: 1;
                color: var(--color-secondary);
                text-align: left;

                &::after {
                    position: absolute;
                    bottom: 50%;
                    display: inline;
                    width: 100%;
                    margin-left: 16px;
                    content: "";
                    border: 1px solid var(--color-grey-600);
                }
            }

            .labelPanel {
                font-size: var(--size-14);
                flex: 1;
                color: var(--color-grey-800);
                text-align: left;
            }

            .valueWrap {
                font-size: var(--size-14);
                display: flex;
                flex: 1;
                color: var(--color-grey-900);
                text-align: left;
                word-break: break-word;

                a,
                .link.link.link {
                    font-weight: normal;
                    color: var(--color-primary);
                }

                svg {
                    width: 30px;
                    height: 30px;
                    margin-right: 15px;
                    cursor: pointer;
                }

                .link {
                    color: -webkit-link;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }

            .valuesContainer {
                flex: 1 1 100%;
            }

            .featuresContainer {
                flex: 1 1 100%;
            }
        }
    }

    .contentPanelAccordion {
        overflow: hidden;
        border-radius: var(--radius-10);
        box-shadow: none;

        .accordion-summary-expandIcon {
            position: absolute;
            top: 16px;
            right: 25px;

            svg {
                path {
                    width: 16px;
                    fill: var(--color-secondary);
                }
            }
        }

        .accordion-summary-root.accordion-summary-root.accordion-summary-root {
            padding: 0;

            .accordion-summary-content {
                display: block;
                margin: 0;
            }
        }

        .accordion-details-root.accordion-details-root.accordion-details-root {
            padding: 0;
            margin-bottom: 5px;
        }

        &::before {
            background-color: transparent;
        }

        &.accordion-rounded:last-child {
            border-radius: var(--radius-10);
        }

        &.accordion-root.Mui-expanded {
            &:last-child {
                margin-bottom: 5px;
            }

            .contentPanel {
                padding-bottom: 0;
            }
        }
    }

    #detailPanelInfo-header {
        background-color: transparent;
        box-shadow: none;

        .accordion-summary-root {
            padding: 0 10px 0 0;

            .accordion-summary-content {
                margin: 0;
            }
        }

        .accordion-details-root {
            padding: 0;
        }
    }
`;

export const StyledPaymentBlock = styled.div<{ $withBorderBottom: boolean }>`
    display: flex;
    flex-direction: row;

    .vertical-date {
        display: flex;
        flex-direction: column;
        text-align: center;

        .date {
            font-size: var(--size-14);
            line-height: 18px;
            color: var(--color-grey-900);
        }

        .month {
            font-size: var(--size-10);
            line-height: 18px;
            color: var(--color-secondary);
            text-transform: uppercase;
        }

        .year {
            font-size: var(--size-10);
            line-height: 16px;
            color: var(--color-grey-800);
        }
    }

    .beneficiary-block {
        display: flex;
        flex: 1;
        flex-direction: column;
        padding-right: 12px;
        padding-left: 12px;

        .beneficiary {
            font-size: var(--size-16);
            line-height: 24px;
            color: var(--color-grey-900);
        }

        .bank-account {
            margin-top: 4px;
            font-size: var(--size-14);
            line-height: 24px;
            color: var(--color-grey-800);
        }
    }

    .amount {
        align-self: center;
        font-size: var(--size-16);
        color: var(--color-grey-900);
    }

    ${(props) =>
        props.$withBorderBottom &&
        `
    padding-top: 8px;
    margin-top: 8px;
    border-top: 1px solid var(--color-grey-600);
  `}
`;
